import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const HelpCenterCollections = React.lazy(() => import(/* webpackChunkName: "HelpCenterCollections" */'./components'));
const routes = () => [
    <PrivateRoute
        key="/settings/help-center/list/:_id"
        exact
        path="/settings/help-center/list/:_id"
        component={({ match }) => {
            return <HelpCenterCollections helpCenterId={match.params._id} />;
        }}
    />
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/HelpCenterCollections/routes.js